module.exports = __webpack_public_path__ + "img/shengjimix.9ecc0fa0.jpg";